<template>
  <div id="react-footer">
    <div data-reactroot="" id="footer" class="footer container" style="width: 100%;">
      <div class="row">
        <div class="col-md-10 col-md-offset-1">
          <div class="row">
            <div class="hidden-sm hidden-xs col-md-2">
              <ul class="list-unstyled">
                <li><router-link to="/">Home</router-link></li>
                <li><a href="#/contact">contact</a></li>
                <li><a href="#/faq">FAQS</a></li>
                <li><a href="#/about">About</a></li>
              </ul>
            </div>
            <div class="col-md-2 col-xs-12">
              <ul class="list-unstyled">
                <!-- <li><router-link class="hidden-sm hidden-xs" to="/faq">Shopper FAQ</router-link></li>
                <li><a class="hidden-sm hidden-xs" href="#/faq-merchants">Seller FAQ</a></li>
                <li><router-link class="hidden-sm hidden-xs" to="/contact">Contact</router-link></li>
                <li><a href="#/terms">Terms of Service</a></li>
                <li><a href="#/merchant-terms">Merchant Terms of Service</a></li>
                <li><a class="hidden-sm hidden-xs" href="#/privacy">Privacy Policy</a></li> -->
              </ul>
            </div>
            <div class="col-md-3 col-xs-6">
              <p class="social"><a href="https://fb.com/"><i class="fab fa-facebook"></i></a><a
                  href="https://twitter.com/"><i class="fab fa-twitter"></i></a><a
                  href="https://instagram.com/"><i class="fab fa-instagram"></i></a></p>
            </div>
            <div class="text-right col-md-2 col-md-offset-1 col-xs-6" style="cursor: default;">
              <p>Koio deal</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  computed: {
    currentYear() {
      return new Date().getFullYear()
    }
  }
}
</script>
